import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import bireyselTerapi from "../assets/bireysel-terapi.jpeg";
import grupTerapisi from "../assets/grup-terapisi.jpg";
import workshop from "../assets/workshop.png";
import "./programs.css";

const Programs = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (index) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };
  const [showMore, setShowMore] = useState(false);
  const [showMoreWorkshop, setShowMoreWorkshop] = useState(false);

  const { hash } = useLocation();

  const [openExpertise, setOpenExpertise] = useState(null);
  const toggleExpertise = (index) => {
    if (openExpertise === index) {
      setOpenExpertise(null);
    } else {
      setOpenExpertise(index);
    }
  };

  useEffect(() => {
    if (hash) {
      const targetId = hash.replace("#", "");

      const timer = setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          // Elementin sayfa üzerindeki konumunu buluyoruz
          const targetPosition =
            element.getBoundingClientRect().top + window.pageYOffset;
          const startPosition = window.pageYOffset;
          const distance = targetPosition - startPosition;
          const duration = 2000;
          let start = null;

          const step = (timestamp) => {
            if (!start) start = timestamp;
            const progress = timestamp - start;

            const easeInOutQuad = (t) =>
              t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            const scrollY =
              startPosition +
              distance * easeInOutQuad(Math.min(progress / duration, 1));

            window.scrollTo(0, scrollY);

            if (progress < duration) {
              window.requestAnimationFrame(step);
            }
          };

          window.requestAnimationFrame(step);
        }
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [hash]);

  const scrollToPrograms = () => {
    const element = document.getElementById("programs");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const data = [
    {
      title: "Şema Terapi",
      items: [
        "Şema Terapi, Dr. Jeffrey Young tarafından geliştirilen ve çocuklukta karşılanmamış duygusal ihtiyaçların yetişkinlikteki düşünce, duygu ve ilişki kalıplarına nasıl yansıdığını anlamaya odaklanan bir psikoterapi yaklaşımıdır. Özellikle tekrarlayan ilişki sorunları, yoğun suçluluk ve öfke, yetersizlik ve değersizlik hisleri yaşayan bireyler için etkilidir.",
        "Bu yaklaşım, kişinin erken dönem şemalarını, tetikleyici durumlarını ve içsel modlarını (örn. İncinmiş Çocuk, Cezalandırıcı Ebeveyn) fark etmesini sağlar. Terapide daha sağlıklı, esnek ve ihtiyaçlarla uyumlu tepkiler geliştirilir.",
      ],
    },
    {
      title: "EMDR",
      items: [
        "EMDR (Eye Movement Desensitization and Reprocessing), Dr. Francine Shapiro tarafından geliştirilen, travmatik anıların etkisini azaltmaya yönelik bilimsel bir terapi yöntemidir. Travma, kaygı, fobiler, özgüven sorunları ve geçmişten taşınan duygusal yüklerin iyileştirilmesinde etkilidir.",
        "Seans sırasında çift yönlü uyarım (göz hareketleri, dokunsal ya da işitsel uyaranlar) eşliğinde zihin doğal bir işlemleme sürecine girer. Bu sayede travmatik anıların duygusal yoğunluğu azalır, bedendeki gerginlik çözülür ve kişi deneyimlerine daha dengeli bir açıdan yaklaşabilir. EMDR sadece büyük travmalar için değil; tekrarlayıcı ihmal veya eleştiri gibi zorlayıcı deneyimler için de uygulanabilir.",
      ],
    },
    {
      title: "Psikodinamik Terapi",
      items: [
        "Psikodinamik Terapi, kökleri Sigmund Freud’un psikanalitik kuramına dayanan; daha sonra nesne ilişkileri ve modern psikanalitik ekollerle zenginleşen bir yaklaşımdır. Kişinin bugün yaşadığı duygusal zorlukları; çocukluk deneyimleri, ilişkisel örüntüler ve bilinçdışı süreçler bağlamında anlamaya odaklanır.",
        "Değersizlik duyguları, kimlik arayışı, ilişki problemleri ve yoğun içsel eleştiri gibi temalarda etkilidir. Seanslarda tekrar eden döngüler, içsel çatışmalar, savunmalar ve aktarımlar üzerinde çalışılır. Böylece yalnızca semptomların azalması değil, kişinin kendilik deneyimini derinlemesine anlaması ve yeniden yapılandırması mümkün olur.",
      ],
    },
    {
      title: "Somatik Deneyimleme ve Beden Odaklı Yaklaşımlar",
      items: [
        "Somatik Deneyimleme®, Dr. Peter Levine tarafından geliştirilmiş, bedende kayıtlı travmatik yüklerle çalışarak sinir sisteminin yeniden dengelenmesini hedefleyen bir yöntemdir. Beden odaklı terapi; özellikle travma sonrası belirtiler, kaygı, öfke, donukluk ve yoğun bedensel gerilim yaşayan bireyler için faydalıdır.",
        "Seanslarda nefes çalışmaları, duyum takibi, postür farkındalığı ve mikro hareketler gibi araçlar kullanılır. Böylece bastırılmış veya donmuş duygusal yükler güvenli şekilde boşalır, kişi bedeninde daha dengeli ve düzenlenmiş hisseder. Bu yaklaşım, bireyin bedeniyle yeniden bağ kurmasına ve regülasyon becerilerini geliştirmesine destek olur.",
      ],
    },
  ];

  const grupTerapisiLongText = `
  <div>
<p>
  Grup terapisi; benzer deneyimleri paylaşan bireylerin güvenli bir ortamda bir araya gelerek 
  öğrenmeyi, bağlantı kurmayı ve farkındalığı artırmayı hedeflediği bir süreçtir. 
  Düzenli oturumlarla kapalı grup şeklinde ilerleyen grup çalışmaları hem bireysel hem de 
  kolektif iyileşmeye katkı sağlar.
</p>

<p>
  <strong>Şema Terapi Teknikleriyle Şefkat Odaklı Grup Müdahalesi</strong>
  <br>
  Utanç duygusu ve sert öz-eleştiri, çoğu zaman kişinin kendisiyle ilişkisini derinden zedeleyerek 
  değersizlik, yalnızlık ve depresif hisleri besler. Bu grup programı, Şema Terapi’nin yaşantısal 
  teknikleri (örn. imgeleme, yeniden ebeveynlik, sandalye çalışmaları) ile 
  Öz-Şefkat Odaklı Terapi yaklaşımını bir araya getirir.
</p>

<p>
  Amaç; katılımcıların içlerindeki sert eleştirel sesi fark edip yumuşatmaları, 
  kırılgan çocuk yönleriyle temas kurmaları ve kendilerine karşı daha şefkatli bir bakış açısı 
  geliştirmeleridir. Grup ortamı sayesinde katılımcılar benzer deneyimlere sahip kişilerle bağ kurar, 
  utanç duygusunun yalnızca kendilerine özgü olmadığını görür ve şefkatli bir paylaşım içinde 
  iyileşme sürecini desteklerler.
</p>

<p><strong>Program kapsamında:</strong></p>

<ul>
  <li>Öz eleştiri ve öz şefkat üzerine psikoeğitim</li>
  <li>Mod farkındalığı çalışmaları</li>
  <li>İmgeleme ve sınırlı yeniden ebeveynlik</li>
  <li>Boş sandalye teknikleri</li>
  <li>Öz şefkat mektupları ve paylaşım</li>
</ul>

<p>
  <strong>Not:</strong> Bu grup terapisi programının tarihleri henüz netleştirilmemiştir.<br>
  Sorularınız, görüşleriniz veya ön kayıt için lütfen iletişime geçiniz.
</p>
</div>
`;

  const grupTerapisiShortText = `Grup terapisi; benzer deneyimleri paylaşan bireylerin güvenli bir ortamda bir araya gelerek öğrenmeyi, bağlantı kurmayı ve farkındalığı artırmayı hedeflediği bir süreçtir. Düzenli oturumlarla kapalı grup şeklinde ilerleyen grup çalışmaları hem bireysel hem de kolektif iyileşmeye katkı sağlar.`;

  const workshopLongText = `
  <div>
  <p>
  Atölyeler; belirli bir tema veya beceri üzerine odaklanan, kısa süreli ve yoğun deneyimsel çalışma alanlarıdır. 
  Grup formatında yürütülen bu buluşmalarda, katılımcılar hem kendi içsel süreçlerini keşfeder hem de benzer 
  deneyimleri paylaşan kişilerle etkileşim kurarak öğrenme fırsatı bulur.
</p>

<p>
  Amaç; bireylere günlük yaşamda kullanabilecekleri pratik araçlar kazandırmak, farkındalık geliştirmek ve 
  kendileriyle daha şefkatli, dengeli bir ilişki kurmalarına destek olmaktır.
</p>

<p>
  Atölyeler genellikle 2–3 saatlik oturumlar şeklinde planlanır ve hem bireysel farkındalık hem de grup 
  deneyiminden yararlanmayı sağlar. Daha çok psikoeğitim ve beceri kazandırma amaçlıdır.
</p>

<p>
  Katılımcılar belirli bir tema üzerine (örn. öz şefkat, mindfulness, sınırlar, duyguları tanıma) pratik bilgiler 
  ve egzersizler öğrenir. Terapi sürecinden ziyade, kişisel gelişim ve farkındalık ağırlıklıdır.
</p>

<p>
  <strong>Not:</strong> Güncel atölye tarihleri ve kayıt bilgileri için lütfen iletişime geçiniz.
</p>
</div>
`;
  const workshopShortText = ` Atölyeler; belirli bir tema veya beceri üzerine odaklanan, kısa süreli ve yoğun deneyimsel çalışma alanlarıdır. Grup formatında yürütülen bu buluşmalarda, katılımcılar hem kendi içsel süreçlerini keşfeder hem de benzer deneyimleri paylaşan kişilerle etkileşim kurarak öğrenme fırsatı bulur. Amaç; bireylere günlük yaşamda kullanabilecekleri pratik araçlar kazandırmak, farkındalık geliştirmek ve kendileriyle daha şefkatli, dengeli bir ilişki kurmalarına destek olmaktır.
`;

  const areasOfExpertiseData = [
    {
      title: "Travma ve İlişkili Zorluklar",
      items: [
        "Çocukluk çağı ihmal ve istismar yaşantıları",
        "Travmatik olaylar sonrası gelişen stres tepkileri",
        "Kompleks travma ve uzun süreli duygusal yaralanmalar",
        "Yas ve kayıp deneyimleri",
        "Gerçek dışılık ve kopma hissi (disosiyasyon, depersonalizasyon, derealizasyon)",
        "Boşluk hissi ve kimlikte süreklilik güçlüğü",
      ],
    },
    {
      title: "İlişkiler ve Bağlanma Dinamikleri",
      items: [
        "Tekrarlayan ilişki döngüleri ve çatışmalar",
        "Terk edilme korkusu, kıskançlık ve yoğun yakınlık kaygıları",
        "Bağlanma stilleriyle çalışma",
        "Sınır koyma güçlükleri ve kendini feda etme eğilimi",
      ],
    },
    {
      title: "Kimlik Gelişimi, Öz-Değer ve Kendilik Algısı",
      items: [
        "Yetersizlik ve değersizlik düşünceleri",
        "Yüksek standartlar ve mükemmeliyetçilik",
        "Varoluşsal sorgulamalar, anlam arayışı",
      ],
    },
    {
      title: "Duygularla Çalışmak ve Duygu Düzenleme Güçlükleri",
      items: [
        "Depresif duygu durum, çökkünlük, enerji kaybı",
        "Duygusal dalgalanmalar ve yoğun ruh hali değişimleri",
        "Bastırılmış öfke, ani öfke patlamaları",
        "Suçluluk ve utanç duygularıyla baş etmekte zorlanma",
        "Keyif alamama, hayata karşı ilgi ve motivasyon kaybı",
        "Duygularından kopukluk, donukluk hissi",
      ],
    },
    {
      title: "Kaygı Odaklı Güçlükler",
      items: [
        "Yaygın kaygı ve yoğun endişe",
        "Sosyal kaygı",
        "Panik atak ve beden odaklı kaygılar",
        "Kaçınma davranışları",
        "Fobiler (sosyal fobi, özgül fobi, uçuş korkusu vb.)",
      ],
    },
    {
      title: "Obsesif Kompulsif ve İlişkili Zorluklar",
      items: [
        "İstenmeyen ve tekrarlayıcı düşüncelerle aşırı meşgul olma(hijyen/temizlik, dini-ahlaki, cinsel veya zarar verme temaları)",
        "Kaygıyı azaltmak için yapılan ritüeller/tekrar davranışları(temizlik, kontrol etme, sayma, dua etme/akıldan tekrar etme vb.)",
      ],
    },
    {
      title: "Yeme Davranışı ve Beden Algısı",
      items: [
        "Duygusal yeme",
        "Yeme davranışıyla ilişkili kontrol arayışı (kısıtlama/tıkınma döngüleri)",
        "Beden imajı kaygıları",
      ],
    },
    {
      title: "Kişilik Örgütlenmeleri",
      items: [
        "Sınırda (Borderline) kişilik örgütlenmesi",
        "Kaçıngan ve bağımlı kişilik örüntüleri",
        "Narsisistik kişilik özellikleri",
        "Kuşkucu (paranoid) ve obsesif kişilik yapıları",
      ],
    },
  ];

  return (
    <>
      {/* Çalışma Alanlarım */}
      <div id="areasOfExpertise" className="row">
        <div className="col md-6 m-5" style={{ paddingLeft: "80px" }}>
          <h1 style={{ fontSize: "clamp(40px, 8vw, 60px)", lineHeight: "1.1" }}>
            Çalışma
          </h1>
          <h1 style={{ fontSize: "clamp(40px, 8vw, 60px)", lineHeight: "1.1" }}>
            Alanlarım
          </h1>
        </div>
        <div className="col md-6 m-5">
          <div
            className="accordion"
            style={{ width: "100%", transform: "translateX(-100px)" }}
          >
            {areasOfExpertiseData.map((section, index) => (
              <div
                key={index}
                style={{
                  borderBottom: "1px solid black",
                  padding: "0.5rem 0",
                }}
              >
                {/* Ana Başlık */}
                <div
                  onClick={() => toggleExpertise(index)}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>{section.title}</span>
                  <span
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      marginLeft: "80px",
                    }}
                  >
                    {openExpertise === index ? "−" : "+"}
                  </span>
                </div>

                {/* Alt Maddeler */}
                {openExpertise === index && (
                  <ul
                    style={{
                      marginTop: "0.5rem",
                      marginBottom: 0,
                      paddingLeft: "1.8rem",
                    }}
                  >
                    {section.items.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Cardlar */}
      <div id="programs" className="container my-4">
        <div className="row">
          <div className="col-12 col-md-4 mb-4">
            <div className="card p-3 h-100">
              <img
                src={bireyselTerapi}
                alt="Bireysel Terapi"
                className="img-fluid mb-4"
                style={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  margin: "0 auto",
                }}
              />
              <div className="card-body">
                <h5 className="fw-bold">Bireysel Terapi</h5>
                <p>
                  Bireysel terapi; kişinin iç dünyasını daha yakından
                  tanımasına, zorlayıcı düşünce ve duygularla başa çıkmasına ve
                  yaşamında daha sağlıklı seçimler yapmasına yardımcı olan
                  profesyonel bir destek sürecidir. Bireysel terapiye başlamak
                  için iletişim bilgilerim üzerinden randevu oluşturabilirsiniz.
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4 mb-4">
            <div className="card p-3 h-100">
              <img
                src={grupTerapisi}
                alt="Grup Terapisi"
                className="img-fluid mb-4"
                style={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  margin: "0 auto",
                }}
              />
              <div className="card-body">
                <h5 className="fw-bold">Grup Terapisi</h5>
                <div className="card-text mb-3">
                  {showMore ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: grupTerapisiLongText }}
                    />
                  ) : (
                    <span>{grupTerapisiShortText}</span>
                  )}
                </div>
                <button
                  onClick={() => {
                    if (showMore) scrollToPrograms();
                    setShowMore(!showMore);
                  }}
                  style={{
                    backgroundColor: "white",
                    outline: "none",
                    borderColor: "#be2d01f4",
                    padding: "5px",
                  }}
                >
                  {showMore ? "Daha Az Göster" : "Daha Fazla Göster"}
                </button>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4 mb-4">
            <div className="card p-3 h-100">
              <img
                src={workshop}
                alt="Atölye/Workshop"
                className="img-fluid mb-4"
                style={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  margin: "0 auto",
                }}
              />
              <div className="card-body">
                <h5 className="fw-bold">Atölye / Workshop</h5>
                <div className="card-text mb-3">
                  {showMoreWorkshop ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: workshopLongText }}
                    />
                  ) : (
                    <span>{workshopShortText}</span>
                  )}
                </div>
                <button
                  onClick={() => {
                    if (showMoreWorkshop) scrollToPrograms();
                    setShowMoreWorkshop(!showMoreWorkshop);
                  }}
                  style={{
                    backgroundColor: "white",
                    outline: "none",
                    borderColor: "#be2d01f4",
                    padding: "5px",
                  }}
                >
                  {showMoreWorkshop ? "Daha Az Göster" : "Daha Fazla Göster"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Terapi Yaklaşımları */}
      <div id="therapyApproaches" style={{ backgroundColor: "white" }}>
        <div className="approaches-container">
          <h1 className="approaches-title">Terapi Yaklaşımlarım</h1>

          <div style={{ width: "100%", maxWidth: "800px" }}>
            {data.map((section, index) => (
              <div
                key={index}
                style={{
                  borderBottom: "1px solid whitesmoke",
                  padding: "1rem 0.5rem",
                  color: "whitesmoke",
                }}
              >
                <div
                  onClick={() => toggle(index)}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <span style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
                    {section.title}
                  </span>
                  <span style={{ fontSize: "24px" }}>
                    {openIndex === index ? "−" : "+"}
                  </span>
                </div>

                {openIndex === index && (
                  <div style={{ marginTop: "1rem", lineHeight: "1.6" }}>
                    {section.items.map((item, i) => (
                      <p key={i} style={{ marginBottom: "10px" }}>
                        {item}
                      </p>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Programs;
